module.exports = __webpack_public_path__ + "img/about-content-0.29439a0c.png";